/**
 * InfoPanel 组件 — 详情页信息面板
 * 默认展示：材料标签 + 概述/工艺/文化页签
 * （藏品/史料/原型标签在 DetailView 的固定底栏中，点击后底部弹窗展示）
 */

/**
 * 渲染信息面板内容
 */
export function renderInfoPanel(data) {
  const tabs = [
    { key: 'overview', label: '概述' },
    { key: 'craft', label: '工艺' },
    { key: 'culture', label: '文化' }
  ];

  return `
    <div class="detail-panel-header">
      <div class="detail-panel-era">
        <span class="pill">${data.era}</span>
        <span class="detail-panel-years">${data.period}</span>
      </div>
      ${data.significance ? `<p class="detail-panel-period">${data.significance}</p>` : ''}
      <div class="material-tags">${data.materials.map(m => `<span class="material-tag">${m}</span>`).join('')}</div>
    </div>

    <div class="tab-group" id="info-tabs">
      ${tabs.map(t => `
        <button class="tab ${t.key === 'overview' ? 'active' : ''}" data-tab="${t.key}">${t.label}</button>
      `).join('')}
    </div>

    <div class="detail-panel-body">
      ${tabs.map(t => `
        <div class="tab-content detail-tab-content" data-tab="${t.key}" style="display: ${t.key === 'overview' ? 'block' : 'none'}">
          <p>${data.tabs[t.key]}</p>
        </div>
      `).join('')}
    </div>
  `;
}
